import { LOCAL_STORAGE_KEYS } from "@auth-frontend-vue/const";

const AUTO_ADD_COOLDOWN_MS = 86_400_000; // 24 * 60 * 60 * 1000;

export function hasPasskeyUsedLocally(): boolean {
    return localStorage.getItem(LOCAL_STORAGE_KEYS.PASSKEY_USED_LOCALLY) === "1";
}

export function setPasskeyUsedLocally(): void {
    localStorage.setItem(LOCAL_STORAGE_KEYS.PASSKEY_USED_LOCALLY, "1");
}

export function clearPasskeyUsedLocally(): void {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.PASSKEY_USED_LOCALLY);
}

export function canAutoAddPasskey(userId: string): boolean {
    const raw = localStorage.getItem(`${LOCAL_STORAGE_KEYS.PASSKEY_AUTO_ADD_PROMPTED_AT}:${userId}`);
    if (!raw) return true;
    const promptedAt = Number(raw);
    if (!Number.isFinite(promptedAt)) return true;
    return Date.now() - promptedAt >= AUTO_ADD_COOLDOWN_MS;
}

export function setPasskeyAutoAddPromptedAt(userId: string): void {
    localStorage.setItem(`${LOCAL_STORAGE_KEYS.PASSKEY_AUTO_ADD_PROMPTED_AT}:${userId}`, String(Date.now()));
}
